import { useId, type CSSProperties, type ReactNode } from 'react';
import styles from './Slider.module.css';

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  label: ReactNode;
  min?: number;
  max?: number;
  step?: number;
  /** Text shown next to the label, e.g. "80 %". */
  valueText?: string;
  disabled?: boolean;
}

/** Labelled range input. Native `<input type="range">` keeps keyboard and screen-reader support. */
export function Slider({
  value,
  onChange,
  label,
  min = 0,
  max = 1,
  step = 0.01,
  valueText,
  disabled = false,
}: SliderProps) {
  const id = useId();
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className={styles['field']}>
      <div className={styles['head']}>
        <label htmlFor={id} className={styles['label']}>
          {label}
        </label>
        {valueText ? (
          <output htmlFor={id} className={styles['value']}>
            {valueText}
          </output>
        ) : null}
      </div>
      <input
        id={id}
        className={styles['range']}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-valuetext={valueText}
        style={{ '--fill': `${pct}%` } as CSSProperties}
        onChange={(e) => {
          onChange(Number(e.target.value));
        }}
      />
    </div>
  );
}
